import $ from 'jquery';
import { getFileExtension } from '@/js/modules/file_validation';

// Helpers shared by the image uploaders: previews made before the server processes a file,
// upload file names, and the item ids a js-uploader form submits.
function scaleCropImage(imgData, size) {
  return new Promise(function (resolve, reject) {
    const img = new Image();
    img.onload = function () {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      const origWidth = img.width;
      const origHeight = img.height;

      const min = Math.min(origWidth, origHeight);
      const ratio = min / size;

      let offsetX;
      let offsetY;

      if (ratio !== 1) {
        // scale the image if necessary
        const newWidth = Math.round(origWidth / ratio);
        const newHeight = Math.round(origHeight / ratio);

        canvas.width = newWidth;
        canvas.height = newHeight;
        ctx.drawImage(img, 0, 0, newWidth, newHeight);

        const res = canvas.toDataURL();
        img.src = res;

        if (origWidth === size && origHeight === size) {
          resolve(res);
        }
      } else if (!(origWidth === size && origHeight === size)) {
        // crop the image if necessary
        canvas.width = size;
        canvas.height = size;

        offsetX = (origWidth - size) / 2;
        offsetY = (origHeight - size) / 2;

        ctx.drawImage(img, -offsetX, -offsetY);

        resolve(canvas.toDataURL());
      } else {
        // no changes necessary
        canvas.width = size;
        canvas.height = size;
        ctx.drawImage(img, 0, 0);

        resolve(canvas.toDataURL());
      }
    };
    img.onerror = function () {
      resolve();
    };
    img.src = imgData;
  });
}

function getHeicPlaceholder(fileName) {
  const ext = getFileExtension(fileName);
  return ext === 'heic' || ext === 'heif' ? '/img/shared/heic-processing-thumb.png' : '';
}

export function previewImageSource(originalSource, fileName) {
  const placeholder = getHeicPlaceholder(fileName);
  return placeholder || originalSource;
}

export function prepareImagePreview(imgData, fileName, size) {
  const placeholder = getHeicPlaceholder(fileName);
  if (placeholder) {
    return Promise.resolve(placeholder);
  }
  return scaleCropImage(imgData, size);
}

export function extractItemIds($parent) {
  // form can have multiple uploaders so we need to get all item ids from them
  const itemIds = $('.uploader__thumb')
    .map((i, el) => {
      return $(el).data().id;
    })
    .get()
    .join(',');

  $parent.find('.uploader__item-ids').val(itemIds);
  if ($parent.hasClass('uploader--custom-question')) {
    $parent.find('.uploader__custom-question-image-ids').val(itemIds);
  }
}

// replace restricted characters to '_'
export const stripFileName = (name) => {
  name = encodeURI(name);
  return name
    .substring(name.lastIndexOf('\\') + 1)
    .split(' ')
    .join('_')
    .replace(/[&$+,:;=?@<>\[\]\{\}\|\^~%#]/g, '_')
    .substr(0, 255);
};
